import LinearProgress from '@mui/material/LinearProgress';
import React from 'react';

export const GlobalProgressBar: React.FC = () => (
  <LinearProgress
    sx={{
      left: 0,
      position: 'absolute',
      right: 0,
      top: 0,
      zIndex: 10,
    }}
  />
);
